import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "availability" }
const _hoisted_2 = { class: "availability-container" }
const _hoisted_3 = { class: "availability-container__inputs" }
const _hoisted_4 = {
  key: 0,
  class: "display-route"
}
const _hoisted_5 = { class: "availability-container__calendar" }
const _hoisted_6 = {
  key: 0,
  class: "date-details__isLoading"
}
const _hoisted_7 = {
  href: "/booking-start",
  class: "booking-link"
}

import Calendar from "@/modules/AvailabilityCalendar/components/AvailabilityCalendar.vue";
import CalendarSelections from "@/modules/AvailabilityCalendar/components/CalendarSelections.vue";
import useAvailabilityFiltersQuery from "@/modules/AvailabilityCalendar/composables/useAvailabilityFiltersQuery";
import useCalendarQuery from "@/modules/AvailabilityCalendar/composables/useCalendarQuery";
import { computed } from "vue";
import { monthChangeEvent } from "./models/AvailabilityDate";
import { FilterState } from "./models/AvailabilityFilter";
import { VBtn } from "v-ferry-components";
import SvgSprite from "@/components/base/SvgSprite.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { data: filters, isLoading: isLoadingFilters } = useAvailabilityFiltersQuery();

const { dates, isLoading, params, updateParams } = useCalendarQuery();

const route = computed(() => filters.value?.routes.find((r) => r.value === params.value.route)?.label);

const onFiltersUpdate = (filters: FilterState) => {
    updateParams({ ...params.value, ...filters });
};

const onDateChange = (date: monthChangeEvent) => {
    updateParams({ ...params.value, month: date.month, year: date.year });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SvgSprite),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "availability-container__header" }, [
        _createElementVNode("h2", null, "Availability calendar"),
        _createElementVNode("p", null, " Thank you for using our availability checker, which gives you an indication of the cabins and car deck space that may be available on future ferry sailings between Aberdeen, Kirkwall and Lerwick. A Pentland Firth availability calendar will be available soon. On sailings where cabins or car deck space is not available, there may still be space, seats, and pods for passengers. "),
        _createElementVNode("br"),
        _createElementVNode("p", null, [
          _createTextVNode(" Please note that passengers should use the "),
          _createElementVNode("a", {
            class: "link",
            href: "http://www.northlinkferries.co.uk/booking-start/"
          }, "online booking system"),
          _createTextVNode(" to confirm availability and reservations are not confirmed until the booking has been paid for in full. ")
        ]),
        _createElementVNode("br"),
        _createElementVNode("p", null, " Please note - cabins shown here on the day of sailing may not be available after the ship has departed from Aberdeen or Lerwick. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CalendarSelections, {
          onUpdateFilters: onFiltersUpdate,
          filters: _unref(filters),
          isLoadingConfig: _unref(isLoadingFilters),
          isLoadingUpdate: _unref(isLoading)
        }, null, 8, ["filters", "isLoadingConfig", "isLoadingUpdate"])
      ]),
      (route.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(route.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Calendar, {
          onDateChange: onDateChange,
          hasVehicle: !!_unref(params).vehicle,
          hasCabin: !!_unref(params).cabin,
          attributes: _unref(dates)
        }, null, 8, ["hasVehicle", "hasCabin", "attributes"]),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(BaseSpinner, {
                color: "pink",
                size: 20
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("a", _hoisted_7, [
        _createVNode(_unref(VBtn), {
          disable: !_unref(dates)?.length
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("Book now")
          ])),
          _: 1,
          __: [0]
        }, 8, ["disable"])
      ])
    ])
  ]))
}
}

})